import { render } from "./Login.vue?vue&type=template&id=84697308&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=84697308&scoped=true&lang=less"

import exportComponent from "/Users/binyu/fe/eshop-vant4-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84697308"]])

export default __exports__